import { forwardRef } from "react";
import dgs from "../assets/dgs_logo.webp";
import worldmedia from "../assets/logo_worldmediafestivals.webp";
import { Container } from "../components/Layout/Container";
import { Section } from "../components/Layout/Section";
import Marquee from "react-fast-marquee";
import styled from "@emotion/styled";
import SectionTitle from "../components/SectionTitle";

const AwardWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const AwardTitle = styled("p")(() => ({
  margin: 0,
  textAlign: "left",
  width: "100%",
  fontSize: 16,
  paddingBottom: ".5rem",
  color: "#fff",
}));

const AwardImage = styled("div", {
  shouldForwardProp: (prop) => prop !== "img",
})<{ img: Object }>(({ img }) => ({
  backgroundImage: `url(${img})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "contain",
  height: 150,
  width: 200,
  filter: "grayscale(100%)",
}));

const AwardSubtitle = styled("p")(() => ({
  margin: 0,
  fontWeight: 400,
  fontSize: 12,
  color: "rgba(255,255,255,.7)",
}));

const AwardsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "6rem",
}));

const StyledSection = styled(Section)(() => ({
  background:
    "radial-gradient(62.1% 87.2% at 50% 120%, rgb(44, 59, 232) 0%, rgb(0, 7, 31) 100%)",
  boxShadow: "rgb(8, 8, 8) 0 -1px 0 0",
}));

const StyledMarquee = styled(Marquee)(() => ({
  gap: "6rem",
}));

const WhiteSectionTitle = styled(SectionTitle)(() => ({
  color: "#fff",
}));

export const Awards = forwardRef<HTMLDivElement, unknown>((props, ref) => (
  <StyledSection ref={ref} id={"awards"}>
    <Container>
      <WhiteSectionTitle>Awards</WhiteSectionTitle>
    </Container>
    <StyledMarquee gradient={false} speed={50}>
      <AwardsWrapper>
        <AwardWrapper>
          <AwardImage img={dgs} />
          <AwardTitle>Ausgezeichnet mit dem 1. Platz beim</AwardTitle>
          <AwardSubtitle>Golden City Gate - Award 2018</AwardSubtitle>
        </AwardWrapper>
        <AwardWrapper>
          <AwardImage img={dgs} />
          <AwardTitle>Ausgezeichnet mit dem 2. Platz beim</AwardTitle>
          <AwardSubtitle>Golden City Gate - Award 2017</AwardSubtitle>
        </AwardWrapper>
        <AwardWrapper>
          <AwardImage img={worldmedia} />
          <AwardTitle>WorldMediaFestival Hamburg 2018</AwardTitle>
          <AwardSubtitle>intermedia-globe SILER - Category</AwardSubtitle>
          <AwardSubtitle>Advertising: Cinema Commercials</AwardSubtitle>
        </AwardWrapper>
      </AwardsWrapper>
    </StyledMarquee>
  </StyledSection>
));
